/*
 * @Author: liang.xuemei
 * @Date: 2021-06-11 10:52:34
 * @LastEditTime: 2021-06-16 16:32:18
 * @LastEditors: liang.xuemei
 * @Description: 
 * @FilePath: \kts-op-e-ticket\src\utils\Doc\index.ts
 */
import Date from './Date';
import Check from './Check'; 
import Calculate from './Calculate';
import Money from './Money';
import Code from './Code';
import Table from './Table';
import Amount from './Amount';

/**
 * 判断一个字符串得字节长度
 * @param str 
 * @returns 
 */
 export function bytesLnegth(str: string) {
    var count = str.length;
    for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 255) {
            count++;
        }
    }
    return count;
}
export function null2str(data: any) {
    if (typeof data !== 'object' || data === null || data === 'null') {
        data = '';
        return data;
    } else {
        for (let x in data) {
            if (data[x] === null || data[x] === 'null') { // 如果是null 把直接内容转为 ''
                data[x] = '';
            } else {
                if (Array.isArray(data[x])) { // 是数组遍历数组 递归继续处理
                    data[x] = data[x].map(z => {
                        return null2str(z);
                    });
                }
                if (typeof (data[x]) === 'object') { // 是json 递归继续处理
                    data[x] = null2str(data[x]);
                }
            }
        }
        return data;
    }
}
export function cutStr(str: string, L: number) {
    var result = '',
        strlen = str.length, // 字符串长度
        chrlen = str.replace(/[^\x00-\xff]/g, '**').length; // 字节长度

    if (chrlen <= L) { return str; }

    for (var i = 0, j = 0; i < strlen; i++) {
        var chr = str.charAt(i);
        if (/[\x00-\xff]/.test(chr)) {
            j++; // ascii码为0-255，一个字符就是一个字节的长度
        } else {
            j += 2; // ascii码为0-255以外，一个字符就是两个字节的长度
        }
        if (j <= L) { // 当加上当前字符以后，如果总字节长度小于等于L，则将当前字符真实的+在result后
            result += chr;
        } else { // 反之则说明result已经是不拆分字符的情况下最接近L的值了，直接返回
            return result;
        }
    }
    return str
}

export default { 
    /** 日期格式处理 */
    Date,
    Check, // 校验
    Calculate,
    Money, // 金额
    /** 编码 */
    Code,
    Table,
    Amount,
};



// WEBPACK FOOTER //
// ./src/utils/Doc/index.ts